/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t,n){let o,r=!1;function e(...e){const i=t.apply(this,e);return r&&void 0!==o&&n?.(o,i)?o:(r=!0,o=i,i)}return e}export{t as dedupeResult};
